const systemConfigs = {
  BID_THRESHOLD: 'nthgen.bid.threshold.active',
  BID_INCREMENT_BEFORE: 'nthgen.bid.increment.before.threshold.active',
  BID_INCREMENT_AFTER: 'nthgen.bid.increment.after.threshold.active',
  SHOW_ACTIVE_TIMER: 'traderev.show.active.timer',
  AUTONIQ_LINK: 'traderev.autoniq.base.url',
  DATE_EXPECTED_LIMIT: 'nthgen.date.expected.limit.days.future',
  DATE_EXPECTED_LIMIT_MAX: 'nthgen.date.expected.max.days.future',
  SSO_SHARED_KEY: 'nthgen.sso.shared.key',
  DISTANCE_CONFIGURATIONS: 'traderev.distance.bucket.upper.limit.configuration'
};

export default systemConfigs;
